if (document.querySelector(".settings")) {
    document.querySelectorAll('.multi-select-box .select-users-email').forEach(select => {
        new TomSelect(select, {
            maxItems: null,
            plugins: {
                'checkbox_options': {
                    'checkedClassNames':   ['ts-checked'],
                    'uncheckedClassNames': ['ts-unchecked'],
                }
            },
            allowEmptyOption: true,
        });
    });
}
